import React from 'react';
import {
  DetailActionButton,
  PrimaryDetailActionbarButton,
} from '@eas/common-web';
import { useReimportDialog } from './dialog-actions/reimport-hook';

export function DataSourceActionbar() {
  const { callApi, showButton, dataSourceName } = useReimportDialog();

  return (
    <>
      {showButton && (
        <DetailActionButton
          promptKey="REIMPORT"
          buttonLabel="Úplný reimport"
          dialogText={`Současný obsah datového zdroje ${dataSourceName} bude kompletně smazán/přepsán!`}
          dialogTitle="Varování"
          apiCall={callApi}
          ButtonComponent={PrimaryDetailActionbarButton}
        />
      )}
    </>
  );
}
